import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { CerealSlugs } from "../../../redux/slices/dashboard/dashboard";
import { FC } from "react";
import { syles } from "./CropsMenuStyles";

type CropsMenuParams = {
  cropsSelected: CerealSlugs[];
  setCrop: (crop: { slug: string; translation: string }) => void;
  selectedCrop: { slug: string; translation: string };
  fetchCropInfo: (cropSlug: string) => void;
  t: (key: string) => string;
  allDataResults: { specie: string }[];
};

const CropsMenu: FC<CropsMenuParams> = ({
  cropsSelected,
  setCrop,
  selectedCrop,
  fetchCropInfo,
  t,
  allDataResults,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedSlug = event.target.value;
    const selectedCropData = Array.isArray(cropsSelected)
      ? cropsSelected.find((crop) => crop.slug === selectedSlug)
      : undefined;

    fetchCropInfo(selectedCropData?.slug ?? "barley");

    setCrop({
      slug: selectedCropData?.slug as string,
      translation: selectedCropData?.translation as string,
    });
  };

  const handleChipClick = (crop: CerealSlugs) => {
    fetchCropInfo(crop.slug ?? "barley");

    setCrop({
      slug: crop.slug as string,
      translation: crop.translation as string,
    });
  };

  const filteredCrops = Array.isArray(cropsSelected)
    ? cropsSelected
        .filter(
          (crop) =>
            allDataResults?.some(
              (data) =>
                data.specie.toLowerCase() === crop.translation.toLowerCase(),
            ) ?? false,
        )
        .toSorted((a, b) => a.translation.localeCompare(b.translation))
    : [];

  const hasDataResults = allDataResults && allDataResults.length > 0;
  const hasAvailableCrops = filteredCrops.length > 0;
  const shouldShowChips = filteredCrops.length <= 5 && filteredCrops.length > 0;
  const shouldShowSelect = filteredCrops.length > 5;

  return (
    <div style={syles.cropsMenu}>
      {!hasAvailableCrops ? (
        <Box sx={syles.noDataMessage}>
          {hasDataResults
            ? t("DashboardDynamicCharts.noDataAvailable")
            : t("DashboardDynamicCharts.noCropsAvailable")}
        </Box>
      ) : shouldShowChips ? (
        <Box sx={syles.crops}>
          {filteredCrops.map((crop) => (
            <Chip
              key={crop.slug}
              label={crop.translation}
              variant={selectedCrop.slug === crop.slug ? "filled" : "outlined"}
              onClick={() => handleChipClick(crop)}
              sx={syles.cropChip}
            />
          ))}
        </Box>
      ) : shouldShowSelect ? (
        <Box sx={syles.cropsSelector}>
          <FormControl fullWidth>
            <InputLabel>{t("DashboardDynamicCharts.crops")}</InputLabel>
            <Select
              value={selectedCrop.slug}
              label={t("DashboardDynamicCharts.crops")}
              onChange={handleChange}
            >
              {filteredCrops.map((crop) => (
                <MenuItem key={crop.slug} value={crop.slug}>
                  {crop.translation}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      ) : null}
    </div>
  );
};

export default CropsMenu;
